import { Divider } from '@mui/material'
import { FC } from 'react'
import { MonitoringPanel } from '../../MonitoringPanel'
import { StratificationClusters } from './StratificationClusters'
import { StratificationQUs } from './StratificationQUs'

export const StratificationPanel: FC = () => {
  return (
    <MonitoringPanel>
      <MonitoringPanel.Title>Estratificación</MonitoringPanel.Title>
      <MonitoringPanel.Description>
        Visualice los resultados de la estratificación sobre las unidades de cuantificación.
        <br />
        Luego de clusterizar, se visualizará el resultado de la superposición con la información
        cargada en la tab Uso dentro de datos anualizados.
      </MonitoringPanel.Description>
      <Divider flexItem />
      <StratificationClusters />
      <Divider flexItem />
      <StratificationQUs />
    </MonitoringPanel>
  )
}
